// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-UserCard-styles--root--xU1wM {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  margin: 5px auto;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-UserCard-styles--root--xU1wM {
    flex-flow: row nowrap;
}
  }

@media screen and (min-width: 1024px) {

.src-containers-Profile-UserCard-styles--root--xU1wM {
    position: relative;
    max-width: 620px;
    left: -80px;
}
  }

@media screen and (min-width: 1280px) {

.src-containers-Profile-UserCard-styles--root--xU1wM {
    left: 12.5px;
}
  }

.src-containers-Profile-UserCard-styles--image--k0RWL {
  position: relative;
  display: block;
  width: 75px;
  height: 75px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-UserCard-styles--image--k0RWL {
    width: 100px;
    height: 100px;
}
  }

.src-containers-Profile-UserCard-styles--image--k0RWL > div:first-child {
    width: 100% !important;
    height: 100% !important;
  }

.src-containers-Profile-UserCard-styles--image--k0RWL input[type="file"] {
    position: absolute;
    visibility: hidden;
  }

.src-containers-Profile-UserCard-styles--editable--vOAj8 {
  cursor: pointer !important;
}

.src-containers-Profile-UserCard-styles--changeImage--F0VKY {
  position: absolute !important;
  right: -2px;
  bottom: -2px;
  border-radius: 50%;
  border: 2px solid #fff;
  border: 2px solid var(--mainBackground);
  background-color: #fff;
  background-color: var(--mainBackground);
}

.src-containers-Profile-UserCard-styles--changeImage--F0VKY svg {
    width: 15px !important;
    height: 15px !important;
  }

.src-containers-Profile-UserCard-styles--side--pevXi {
  flex: 1 1;
  margin-left: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 0;
}

.src-containers-Profile-UserCard-styles--side--pevXi > * + * {
    margin-top: 10px;
    max-width: 100% !important;
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-UserCard-styles--side--pevXi {
    margin-left: 20px;
    margin-right: 70px;
}
  }

.src-containers-Profile-UserCard-styles--side--pevXi h1 {
    box-sizing: border-box;
    margin: 0;
    margin: initial;
    padding: 0;
    padding: initial;
    font-size: 22px;
    font-weight: 300;
    line-height: 1.59;
    overflow: hidden;
    text-overflow: ellipsis;
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-UserCard-styles--side--pevXi h1 {
      font-size: 30px;
      line-height: 1.33;
      white-space: nowrap;
  }
    }

.src-containers-Profile-UserCard-styles--side--pevXi button {
    display: inline-block;
    border: 0;
    outline: 0;
    margin: 0;
    margin: initial;
    padding: 0;
    padding: initial;
    background-color: transparent;
    color: #b0b4c2;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    cursor: pointer;
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-UserCard-styles--side--pevXi button {
      margin-top: 5px;
  }
    }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/UserCard/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAelB;;AAbE;;AAPF;IAQI,qBAAqB;AAYzB;EAXE;;AAEA;;AAXF;IAYI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AAMf;EALE;;AAEA;;AAjBF;IAkBI,YAAY;AAEhB;EADE;;AAGF;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AAgBd;;AAdE;;AANF;IAOI,YAAY;IACZ,aAAa;AAYjB;EAXE;;AAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;AAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAuC;EAAvC,uCAAuC;EACvC,sBAAuC;EAAvC,uCAAuC;AAMzC;;AAJE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;AAGF;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AA8Cd;;AA5CE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;;AAZF;IAaI,iBAAiB;IACjB,kBAAkB;AAqCtB;EApCE;;AAEA;IACE,sBAAsB;IACtB,SAAe;IAAf,eAAe;IACf,UAAgB;IAAhB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;EAOzB;;AALE;;AAVF;MAWI,eAAe;MACf,iBAAiB;MACjB,mBAAmB;EAEvB;IADE;;AAGF;IACE,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,SAAe;IAAf,eAAe;IACf,UAAgB;IAAhB,gBAAgB;IAChB,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EAKjB;;AAHE;;AAbF;MAcI,eAAe;EAEnB;IADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: center;\n  margin: 5px auto;\n\n  @media (--desktop) {\n    flex-flow: row nowrap;\n  }\n\n  @media (--desktop-l) {\n    position: relative;\n    max-width: 620px;\n    left: -80px;\n  }\n\n  @media (--desktop-x) {\n    left: 12.5px;\n  }\n}\n\n.image {\n  position: relative;\n  display: block;\n  width: 75px;\n  height: 75px;\n\n  @media (--desktop) {\n    width: 100px;\n    height: 100px;\n  }\n\n  & > div:first-child {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  & input[type=\"file\"] {\n    position: absolute;\n    visibility: hidden;\n  }\n}\n\n.editable {\n  cursor: pointer !important;\n}\n\n.changeImage {\n  position: absolute !important;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 50%;\n  border: 2px solid var(--mainBackground);\n  background-color: var(--mainBackground);\n\n  & svg {\n    width: 15px !important;\n    height: 15px !important;\n  }\n}\n\n.side {\n  flex: 1;\n  margin-left: 15px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  min-width: 0;\n\n  & > * + * {\n    margin-top: 10px;\n    max-width: 100% !important;\n  }\n\n  @media (--desktop) {\n    margin-left: 20px;\n    margin-right: 70px;\n  }\n\n  & h1 {\n    box-sizing: border-box;\n    margin: initial;\n    padding: initial;\n    font-size: 22px;\n    font-weight: 300;\n    line-height: 1.59;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (--desktop) {\n      font-size: 30px;\n      line-height: 1.33;\n      white-space: nowrap;\n    }\n  }\n\n  & button {\n    display: inline-block;\n    border: 0;\n    outline: 0;\n    margin: initial;\n    padding: initial;\n    background-color: transparent;\n    color: #b0b4c2;\n    font-size: 14px;\n    font-weight: 400;\n    text-align: left;\n    cursor: pointer;\n\n    @media (--desktop) {\n      margin-top: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-containers-Profile-UserCard-styles--root--xU1wM`,
	"image": `src-containers-Profile-UserCard-styles--image--k0RWL`,
	"editable": `src-containers-Profile-UserCard-styles--editable--vOAj8`,
	"changeImage": `src-containers-Profile-UserCard-styles--changeImage--F0VKY`,
	"side": `src-containers-Profile-UserCard-styles--side--pevXi`
};
module.exports = ___CSS_LOADER_EXPORT___;
